/**
 * Checks if an object has no entries without expanding it
 */
export default function objectIsEmpty(obj: object | undefined | null) {
  for (const id in obj) {
    if (obj.hasOwnProperty(id)) {
      return false;
    }
  }

  return true;
}
